import { render, staticRenderFns } from "./CoverSpecTable.vue?vue&type=template&id=d78b5fd8&scoped=true&"
import script from "./CoverSpecTable.vue?vue&type=script&lang=ts&"
export * from "./CoverSpecTable.vue?vue&type=script&lang=ts&"
import style0 from "./CoverSpecTable.vue?vue&type=style&index=0&id=d78b5fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78b5fd8",
  null
  
)

export default component.exports